import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';

const FieldNameFormatter = (cell) => {
    return (
        <Typography variant="subtitle2" title={cell}>
            {cell ? cell : '- - -'}
        </Typography>
    );
};

export default FieldNameFormatter;
